import { Card, CardContent } from "@/components/ui/card";

export const FeatureCard = ({ icon, title, description, bgColor }) => (
  <Card className="border-0 shadow-sm">
    <CardContent className="flex items-center gap-4 p-4">
      <div className={`w-12 h-12 rounded-xl ${bgColor} flex items-center justify-center flex-shrink-0`}>
        {icon}
      </div>
      <div>
        <h3 className="font-semibold text-jeekota-text">{title}</h3>
        <p className="text-sm text-jeekota-text-secondary">{description}</p>
      </div>
    </CardContent>
  </Card>
);
